import React from "react";
import "./VideoIndicator.scss";

// Play-circle glyph with a filled triangle (feather-style) — reads more clearly at small size
// than an outlined triangle. Inlined so the one shared token owns its icon.
const PlayCircleFilled = ({ size = 13 }) => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width={size} height={size} aria-hidden="true">
		<circle cx="12" cy="12" r="10" />
		<polygon points="10 8 16 12 10 16 10 8" fill="currentColor" stroke="none" />
	</svg>
);

/**
 * Shared "Video" attribute indicator — a soft-purple tint pill shown inline, immediately after a
 * document title, wherever a document has an attached video (Requests list, Library list, Library
 * document-detail summary row, Commentary Tracker). Driven by a `hasVideo` flag at the call site.
 *
 * One token everywhere: do NOT restyle per surface. The label text ("Video") is visible, so no
 * extra aria label is required.
 */
const VideoIndicator = ({ className }) => (
	<span className={`video-indicator${className ? " " + className : ""}`}>
		<PlayCircleFilled size={13} />
		<span>Video</span>
	</span>
);

export default VideoIndicator;
